import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import OneColumnB from '../components/OneColumnB/OneColumnB'
import OneColumnC from '../components/OneColumnC/OneColumnC'
import FAQS from '../components/FAQS/FAQS'
import RecStructure from '../components/Table/RecStructure'
import images from '../constants/images'
import './Views.css'
import RecPayment from '../components/Payment/RecPayment'
import 'react-tabs/style/react-tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import RecLeague from '../components/RecLeague/RecLeague'
import RecCoaches from '../components/Table/RecCoaches'
import Concessions from '../components/RecLeague/Concessions'
import ImageEnlarge from '../components/ImageEnlarge/ImageEnlarge'


const Recreation = () => {
  // frequently asked question about recreation program use FAQ component to map the data
  const recFaq = [
    { id: 1, question: 'Cost', answer: 'The cost for both fall and spring season is $60 per child and $40 for each additional child in your family. The cost goes to uniform top and managment fees.' },
    { id: 2, question: 'Practices', answer: 'Each team is encourage to practice once a week. Equipment can be accessed at the soccer shed. All practice equipment is shared, please return the equipment to the shed after your practice.' },
    { id: 3, question: 'Length of Season', answer: 'Both fall and spring season is over a 6 week period.' },
    { id: 4, question: 'Equipment', answer: 'If your child has a ball we encourage them to bring it to practices and match day. All players must wear shin guards and soccer boots/cleat to both practices and matches. Practices and matches are played in all weather conditions, minus lighting. We encourage players and coaches to bring weather permitting gear.' },
    { id: 5, question: 'Officiating', answer: 'All U8 to U12 matches are officiated by our youth referees. Our youth referees have been trained to implement the laws of the game. We ask that you exercise patients and respect their rulings during the game are their final call. ' },
    { id: 6, question: 'Environment', answer: 'Recreation matches are for players to learn the game of soccer and have fun. Adult spectators and coaches are to foster a positive environment by encouraging collaboration for all age groups.' }
  ]

  const tableData = [
    { age: "U12", matchLength: "2X 30 minute", ballSize: "4", teamSize: "9v9", offsideRule: "Yes", headers: "No", official: "Yes" },
    { age: "U10", matchLength: "2X 25 minute", ballSize: "4", teamSize: "7v7", offsideRule: "Yes", headers: "No", official: "Yes" },
    { age: "U8", matchLength: "4X 10 minute", ballSize: "3", teamSize: "7v7", offsideRule: "No", headers: "No", official: "Yes" },
    { age: "U6*", matchLength: "4X 8 minute", ballSize: "3", teamSize: "4v4", offsideRule: "No", headers: "No", official: "No" },
  ]

  // U6
  const coachesDataU6 = [
    { ageGroup: 'U6', teamColor: 'RED', },
    { ageGroup: 'U6', teamColor: 'PURPLE', },
    { ageGroup: 'U6', teamColor: 'BLUE', },
    { ageGroup: 'U6', teamColor: 'YELLOW', },
    { ageGroup: 'U6', teamColor: 'GREEN'}
 
  ]
  const scheduleDataU6W1 = [
    { time: '8 AM', homeTeam: 'Allie_T1', awayTeam: 'ISAACSON_T2', field: 'F1' },
    { time: '9 AM', homeTeam: 'THOMSEN_T3', awayTeam: 'JOHNSON_T4', field: 'F1' },
    { time: '10 AM', homeTeam: 'BOHLAND_T5', awayTeam: 'THOMSEN_T3', field: 'F1' }
  ];
  const scheduleDataU6W2 = [
     { time: '8 AM', homeTeam: 'ISAACSON_T2', awayTeam: 'THOMSEN_T3', field: 'F1' },
    { time: '9 AM', homeTeam: 'BOHLAND_T5', awayTeam: 'Allie_T1', field: 'F1' },
    { time: '10 AM', homeTeam: 'BOHLAND_T5', awayTeam: 'JOHNSON_T4', field: 'F1' }
  ];
  const scheduleDataU6W3 = [
    { time: '8 AM', homeTeam: 'ISAACSON_T2', awayTeam: 'BOHLAND_T5', field: 'F1' },
    { time: '9 AM', homeTeam: 'Allie_T1', awayTeam: 'THOMSEN_T3', field: 'F1' },
    { time: '10 AM', homeTeam: 'Allie_T1', awayTeam: 'JOHNSON_T4', field: 'F1' }

  ];
  const scheduleDataU6W4 = [
     { time: '8 AM', homeTeam: 'JOHNSON_T4', awayTeam: 'ISAACSON_T2', field: 'F1' },
    { time: '9 AM', homeTeam: 'THOMSEN_T3', awayTeam: 'JOHNSON_T4', field: 'F1' },
    { time: '10 AM', homeTeam: 'BOHLAND_T5', awayTeam: 'Allie_T1', field: 'F1' }

  ];
  const scheduleDataU6W5 = [
    { time: '8 AM', homeTeam: 'Allie_T1', awayTeam: 'JOHNSON_T4', field: 'F1' },
    { time: '9 AM', homeTeam: 'ISAACSON_T2', awayTeam: 'BOHLAND_T5', field: 'F1' },
    { time: '10 AM', homeTeam: 'BOHLAND_T5', awayTeam: 'THOMSEN_T3', field: 'F1' }
  ];
  const scheduleDataU6W6 = [
  { time: '8 AM', homeTeam: 'ISAACSON_T2', awayTeam: 'THOMSEN_T3', field: 'F1' },
    { time: '9 AM', homeTeam: 'ISAACSON_T2', awayTeam: 'Allie_T1', field: 'F1' },
    { time: '10 AM', homeTeam: 'JOHNSON_T4', awayTeam: 'BOHLAND_T5', field: 'F1' }
  ];


  // U8
  const coachesDataU8 = [
    { ageGroup: 'U8', teamColor: 'RED',  },
    { ageGroup: 'U8', teamColor: 'YELLOW', },
    { ageGroup: 'U8', teamColor: 'BLUE', },
    { ageGroup: 'U8', teamColor: 'PURPLE', }

  ]

  const scheduleDataU8W1 = [
    { time: '8 AM', homeTeam: 'LITWILER_T1', awayTeam: 'ALLERUZZO_HAARS_T3', field: 'E' },
    { time: '9 AM', homeTeam: 'WILKEN_HOUSER_T2', awayTeam: 'DEAN_T4', field: 'E' }
  ];
  const scheduleDataU8W2 = [
    { time: '8 AM', homeTeam: 'LITWILER_T1', awayTeam: 'DEAN_T4', field: 'E' },
    { time: '9 AM', homeTeam: 'WILKEN_HOUSER_T2', awayTeam: 'ALLERUZZO_HAARS_T3', field: 'E' }
  ];
  const scheduleDataU8W3 = [
    { time: '8 AM', homeTeam: 'ALLERUZZO_HAARS_T3', awayTeam: 'DEAN_T4', field: 'E' },
    { time: '9 AM', homeTeam: 'WILKEN_HOUSER_T2', awayTeam: 'LITWILER_T1', field: 'E' }
  ];
  const scheduleDataU8W4 = [
    { time: '8 AM', homeTeam: 'LITWILER_T1', awayTeam: 'ALLERUZZO_HAARS_T3', field: 'E' },
    { time: '9 AM', homeTeam: 'WILKEN_HOUSER_T2', awayTeam: 'DEAN_T4', field: 'E' }
  ];
  const scheduleDataU8W5 = [
    { time: '8 AM', homeTeam: 'LITWILER_T1', awayTeam: 'DEAN_T4', field: 'E' },
    { time: '9 AM', homeTeam: 'WILKEN_HOUSER_T2', awayTeam: 'ALLERUZZO_HAARS_T3', field: 'E' }
  ];
  const scheduleDataU8W6 = [
    { time: '8 AM', homeTeam: 'LITWILER_T1', awayTeam: 'WILKEN_HOUSER_T2', field: 'E' },
    { time: '9 AM', homeTeam: 'DEAN_T4', awayTeam: 'ALLERUZZO_HAARS_T3', field: 'E' }
  ];

  // U10
  const coachesDataU10 = [
    { ageGroup: 'U10', teamColor: 'ORION_1',  },
    { ageGroup: 'U10', teamColor: 'ORION_2',  },
    { ageGroup: 'U10', teamColor: 'SHERRARD_1', },
    { ageGroup: 'U10', teamColor: 'SHERRARD_2',  },

  ]

  const scheduleDataU10W1 = [
    { time: '9AM', homeTeam: 'O_2', awayTeam: 'S_2', field: 'Orion D' },
    { time: '9AM', homeTeam: 'O_1', awayTeam: 'S_1', field: 'Viola' },
  ];
  const scheduleDataU10W2 = [
    { time: '9AM', homeTeam: 'O_1', awayTeam: 'O_2', field: 'Orion D' },
    { time: '9AM', homeTeam: 'S_2', awayTeam: 'S_1', field: 'Viola' },
  ];
  const scheduleDataU10W3 = [
    { time: '9AM', homeTeam: 'O_2', awayTeam: 'S_1', field: 'Orion D' },
    { time: '9AM', homeTeam: 'S_2', awayTeam: 'O_1', field: 'Viola' },

  ];
  const scheduleDataU10W4 = [
    { time: '9AM', homeTeam: 'S_1', awayTeam: 'O_1', field: 'Orion D' },
    { time: '9AM', homeTeam: 'O_2', awayTeam: 'S_2', field: 'Viola' },

  ];
  const scheduleDataU10W5 = [
    { time: '9AM', homeTeam: 'O_1', awayTeam: 'S_2', field: 'Orion D' },
    { time: '9AM', homeTeam: 'S_1', awayTeam: 'O_2', field: 'Viola' },

  ];
  const scheduleDataU10W6 = [
    { time: '9AM', homeTeam: 'O_2', awayTeam: 'O_1', field: 'Orion D' },
    { time: '9AM', homeTeam: 'S_1', awayTeam: 'S_2', field: 'Viola' },

  ];


  // U12
  const coachesDataU12 = [
    { ageGroup: 'U12', teamColor: 'ORION_1',  },
    { ageGroup: 'U12', teamColor: 'ORION_2', },
    { ageGroup: 'U12', teamColor: 'SHERRARD_1',  },
    { ageGroup: 'U12', teamColor: 'SHERRARD_2',  },
  ]
  const scheduleDataU12W1 = [
    { time: '9:30AM', homeTeam: 'O_1', awayTeam: 'S_1', field: 'Orion B' },
    { time: '9:30AM', homeTeam: 'S_2', awayTeam: 'O_2', field: 'Viola' },

  ];
  const scheduleDataU12W2 = [
    { time: '9:30AM', homeTeam: 'O_1', awayTeam: 'O_2', field: 'Orion B' },
    { time: '9:30AM', homeTeam: 'S_2', awayTeam: 'S_1', field: 'Viola' },

  ];
  const scheduleDataU12W3 = [
    { time: '9:30AM', homeTeam: 'O_2', awayTeam: 'S_1', field: 'Orion B' },
    { time: '9:30AM', homeTeam: 'S_2', awayTeam: 'O_1', field: 'Viola' },

  ];
  const scheduleDataU12W4 = [
    { time: '9:30AM', homeTeam: 'O_2', awayTeam: 'S_2', field: 'Orion B' },
    { time: '9:30AM', homeTeam: 'S_1', awayTeam: 'O_1', field: 'Viola' },

  ];
  const scheduleDataU12W5 = [
    { time: '9:30AM', homeTeam: 'O_1', awayTeam: 'S_2', field: 'Orion B' },
    { time: '9:30AM', homeTeam: 'S_1', awayTeam: 'O_2', field: 'Viola' },
  ];

  const scheduleDataU12W6 = [
    { time: '9:30AM', homeTeam: 'O_2', awayTeam: 'O_1', field: 'Orion B' },
    { time: '9:30AM', homeTeam: 'S_1', awayTeam: 'S_2', field: 'Viola' },

  ];
  //Concession stand data mapping 
  // const scheduleDataConcessionW1 = [
  //   { time: '9AM', teamMemberU6: '-.'},
  //   { time: '10AM', teamMemberU6: '-'}

  // ]; 
  // const scheduleDataConcessionW2 = [
  //   { time: '9AM', teamMemberU6: '-' },
  //   { time: '10AM', teamMemberU6: '-' },

  // ];
  // const scheduleDataConcessionW3 = [
  //   { time: '9AM', teamMemberU6: '- ' },
  //   { time: '10AM', teamMemberU6: '- '},

  // ];
  // const scheduleDataConcessionW4 = [
  //   { time: '9AM', teamMemberU6: '-'},
  //   { time: '10AM', teamMemberU6: '-' },

  // ];
  // const scheduleDataConcessionW5 = [
  //   { time: '9AM', teamMemberU6: '-'},
  //   { time: '10AM', teamMemberU6: '-' },

  // ];
  // const scheduleDataConcessionW6 = [
  //   { time: '9AM', teamMemberU6: '-'},
  //   { time: '10AM', teamMemberU6: '-' },

  // ];


  return (
    <div className="app__background">
      <Navbar />
      <div className="app__background section__padding">
        <div className="app__content">
          <h1 className="headtext__roboto" style={{ paddingBottom: '3rem' }}>Recreation</h1>
        </div>
        <div style={{ paddingTop: '1rem', paddingBottom: '0.5rem', }}>
          <h2 className="subheadtext__roboto">2026 Spring Season Schedule</h2>
        </div>
        <div className="tabs__container" >
          <Tabs>
            <TabList >
              <Tab>U6</Tab>
              <Tab>U8</Tab>
              <Tab>U10</Tab>
              <Tab>U12</Tab>
              {/* <Tab>Coaching</Tab>
                <Tab>Concession Stand</Tab>  */}

            </TabList>

            <TabPanel className="tabs__container">
              <h4 className="h4__roboto" style={{ paddingLeft: '1rem', color: '#0b0b0b' }}>U6 Schedule</h4>
              <RecLeague week="Week 1 @ C.R.Hanna Fields" gameDate="Apr. 4, 2026" scheduleGameTime={scheduleDataU6W1} />
              <br></br>
              <RecLeague week="Week 2 @ C.R.Hanna Fields" gameDate="Apr. 11, 2026" scheduleGameTime={scheduleDataU6W2} />
              <br></br>
              <RecLeague week="Week 3 @ C.R.Hanna Fields" gameDate="Apr. 18, 2026" scheduleGameTime={scheduleDataU6W3} />
              <br></br>
              <RecLeague week="Week 4 @ C.R.Hanna Fields" gameDate="Apr. 25, 2026" scheduleGameTime={scheduleDataU6W4} />
              <br></br>
              <RecLeague week="Week 5 @ C.R.Hanna Fields" gameDate="May 2, 2026" scheduleGameTime={scheduleDataU6W5} />
              <br></br>
              <RecLeague week="Week 6 @ C.R.Hanna Fields" gameDate="May 9, 2026" scheduleGameTime={scheduleDataU6W6} />
              <br></br>
              <RecCoaches CoachData={coachesDataU6} />

            </TabPanel>

            <TabPanel>
              <h4 className="h4__roboto" style={{ paddingLeft: '1rem', color: '#0b0b0b' }}>U8 Schedule</h4>
              <RecLeague week="Week 1 @ C.R.Hanna Fields" gameDate="Apr. 4, 2026" scheduleGameTime={scheduleDataU8W1} />
              <br></br>
              <RecLeague week="Week 2 @ C.R.Hanna Fields" gameDate="Apr. 11, 2026" scheduleGameTime={scheduleDataU8W2} />
              <br></br>
              <RecLeague week="Week 3 @ C.R.Hanna Fields" gameDate="Apr. 18, 2026" scheduleGameTime={scheduleDataU8W3} />
              <br></br>
              <RecLeague week="Week 4 @ C.R.Hanna Fields" gameDate="Apr. 25, 2026" scheduleGameTime={scheduleDataU8W4} />
              <br></br>
              <RecLeague week="Week 5 @ C.R.Hanna Fields" gameDate="May 2, 2026" scheduleGameTime={scheduleDataU8W5} />
              <br></br>
              <RecLeague week="Week 6 @ C.R.Hanna Fields" gameDate="May 9, 2026" scheduleGameTime={scheduleDataU8W6} />
              <br></br>
              <RecCoaches CoachData={coachesDataU8} />

            </TabPanel>

            <TabPanel>
              <h4 className="h4__roboto" style={{ paddingLeft: '1rem', color: '#0b0b0b' }}>U10 Schedule</h4>
              <RecLeague week="Week 1" gameDate="Apr. 4, 2026" scheduleGameTime={scheduleDataU10W1} />
              <br></br>
              <RecLeague week="Week 2" gameDate="Apr. 11, 2026" scheduleGameTime={scheduleDataU10W2} />
              <br></br>
              <RecLeague week="Week 3" gameDate="Apr. 18, 2026" scheduleGameTime={scheduleDataU10W3} />
              <br></br>
              <RecLeague week="Week 4" gameDate="Apr. 25, 2026" scheduleGameTime={scheduleDataU10W4} />
              <br></br>
              <RecLeague week="Week 5" gameDate="May 2, 2026" scheduleGameTime={scheduleDataU10W5} />
              <br></br>
              <RecLeague week="Week 6" gameDate="May 9, 2026" scheduleGameTime={scheduleDataU10W6} />
              <br></br>
              <RecCoaches CoachData={coachesDataU10} />
            </TabPanel>

            <TabPanel>
              <h4 className="h4__roboto" style={{ paddingLeft: '1rem', color: '#0b0b0b' }}>U12 Schedule</h4>
              <RecLeague week="Week 1" gameDate="Apr. 4, 2026" scheduleGameTime={scheduleDataU12W1} />
              <br></br>
              <RecLeague week="Week 2" gameDate="Apr. 11, 2026" scheduleGameTime={scheduleDataU12W2} />
              <br></br>
              <RecLeague week="Week 3" gameDate="Apr. 18, 2026" scheduleGameTime={scheduleDataU12W3} />
              <br></br>
              <RecLeague week="Week 4" gameDate="Apr. 25, 2026" scheduleGameTime={scheduleDataU12W4} />
              <br></br>
              <RecLeague week="Week 5" gameDate="May 2, 2026" scheduleGameTime={scheduleDataU12W5} />
              <br></br>
              <RecLeague week="Week 6" gameDate="May 9, 2026" scheduleGameTime={scheduleDataU12W6} />
              <br></br>
              <RecCoaches CoachData={coachesDataU12} />
            </TabPanel>

            <TabPanel>

              {/* <RecCoaches CoachData={coachesDataU6} />
                  <RecCoaches CoachData={coachesDataU8} />
                  <RecCoaches CoachData={coachesDataU10} />
                  <RecCoaches CoachData={coachesDataU12} />
                  </TabPanel>
              <TabPanel> */}
              {/* <h4 className="h4__roboto" style={{ paddingLeft: '1rem', color: '#0b0b0b' }}>Concession Stand Schedule</h4> */}
              {/* <Concessions concessionWeek="Week 1" concessionDate="Apr. 4, 2026" scheduleConcessionTime={scheduleDataConcessionW1} />
                <Concessions concessionWeek="Week 2" concessionDate="Apr. 11, 2026" scheduleConcessionTime={scheduleDataConcessionW2} />
                <Concessions concessionWeek="Week 3" concessionDate="Apr. 18, 2026" scheduleConcessionTime={scheduleDataConcessionW3} />
                <Concessions concessionWeek="Week 4" concessionDate="Apr. 25, 2026" scheduleConcessionTime={scheduleDataConcessionW4} />
                <Concessions concessionWeek="Week 5" concessionDate="May 2, 2026" scheduleConcessionTime={scheduleDataConcessionW5} />
              <Concessions concessionWeek="Week 6" concessionDate="May 9, 2026" scheduleConcessionTime={scheduleDataConcessionW6} />  */}
              <div >
              </div>
            </TabPanel>
          </Tabs>
        </div>
        <div>
          <p className="p__opensans">C.R.Hanna Field Map</p>
          <ImageEnlarge className="scheduleImg" src={images.field_map} alt="field map" />
        </div>
        <div style={{ paddingTop: '2rem' }}>
          <OneColumnB
            subheader="Learning and Discovery"
            paragraph="Our recreation soccer program offers a fall and spring season. Each season lasts six weeks. All coaches are volunteers with the support from our coaching community.
            During these seasons, we provide a platform for players to engage in soccer while emphasizing fun and exploration. "
          />
          <div style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>
            <OneColumnB
              subheader="Why start with Recreation Soccer?"
              paragraph="The primary goal of our recreation soccer program is to create an enjoyable low-level intensity environment for 
              players to learn and develop their soccer skills. While we value skill improvement, we focus on fostering a love for the game and encouraging players to explore their potential. We aim to instill a sense of teamwork, 
              sportsmanship, and camaraderie among the participants."
            />
          </div>
          {/* <RecPayment /> */}
          <div style={{ paddingTop: '2rem' }}>
            <RecStructure RecData={tableData} />
            <p className="p__opensans">* U6 matches DO NOT use the goalkeeper position. All participants on the field are players.</p>
          </div>
          {/* <div>

             <h2 className="tabs__title__rec">Spring 2024 League Schedule</h2> 
          </div> */}
        </div>
        <div className="app__faq app__background">
          <FAQS faqTitle="Recreational FAQ's" faqs={recFaq} />
        </div>
        {/* <RecPayment /> */}
      </div>
      <div>
        <Footer />
      </div>
    </div>
  )
}

export default Recreation